import { useEffect, useState } from 'react';
import { applyTheme, readTheme } from '../lib/theme';
import type { Theme } from '../lib/theme';

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>('light');

  // Doc trong effect chu khong trong useState initializer: luc initializer chay o
  // moi truong khong co DOM (test render) se no loi, con effect thi chi chay o trinh duyet.
  useEffect(() => {
    setTheme(readTheme());
  }, []);

  return (
    <button
      type="button"
      className="cf-btn cf-btn-ghost"
      aria-label={theme === 'dark' ? 'Chuyen sang giao dien sang' : 'Chuyen sang giao dien toi'}
      onClick={() => {
        const next: Theme = theme === 'dark' ? 'light' : 'dark';
        applyTheme(next);
        setTheme(next);
      }}
    >
      <span aria-hidden="true">{theme === 'dark' ? '☾' : '☀'}</span>
      <span className="hidden sm:inline">{theme === 'dark' ? 'Toi' : 'Sang'}</span>
    </button>
  );
}
